module.exports = __webpack_public_path__ + "img/IMG_9701_L_BlackMatted.eaa95d49.jpg";